/**
 *      ▄ █
 *    █ █ ▀▀█  LOADBALANCER CLIENT
 *    █ ▀ ▀ █  @copyright Copyright (c) 2025
 */
import { Injectable } from '@angular/core';

@Injectable()
export class DictionaryService {
    private ukUsLookup = {
        'color': 'colour',
        'license': 'licence',
        'program': 'programme',
        'center': 'centre',
        'organization': 'organisation',
        'organizations': 'organisations',
        'centralised': 'centralized'
    };

    /**
     * Remove US spelling.
     * @param sentence
     */
    public removeUSSpelling(sentence: string,): string {
        const words: string[] = sentence.split(' ');
        const formattedWords: string[] = [];
        for (const word of words) {
            const punctuation: string = this.getPunctuation(word);
            const cleanedWord: string = this.cleanWord(word, punctuation);
            const match = this.ukUsLookup[cleanedWord];
            if (match) {
                const startsWithCap: boolean = this.startsWithCapitalLetter(word);
                const casedWord = startsWithCap ? this.convertFirstLetterToCapital(match) : match;
                formattedWords.push(punctuation ? casedWord + punctuation : casedWord);
            } else {
                formattedWords.push(word);
            }
        }

        return formattedWords.join(' ');
    }

    /**
     * Get punctuation from word.
     * @param word
     */
    private getPunctuation(word: string): string {
        const matches: RegExpMatchArray = word.match(/[.,\/#!%?;:'{}=\-_`~]+(s)?/g);

        return matches && matches.join('');
    }

    /**
     * Clean the word from punctuation and convert to lowercase.
     * @param word
     * @param punctuation
     */
    private cleanWord(word: string, punctuation: string): string {
        return word.replace(punctuation, '').toLowerCase();
    }

    /**
     * Check if the word starts with a capital letter.
     * @param word
     * @private
     */
    private startsWithCapitalLetter(word: string): boolean {
        return /^\p{Lu}/u.test(word);
    }

    /**
     * Convert first letter to capital letter.
     * @param word
     * @private
     */
    private convertFirstLetterToCapital(word: string): string {
        return word.charAt(0).toUpperCase() + word.slice(1);
    }
}
